import React from 'react';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  Box,
  AppBar,
  Tabs,
  Tab,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  Snackbar, Divider,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SchoolIcon from '@mui/icons-material/School';
import PaidIcon from '@mui/icons-material/Paid';
import PublicIcon from '@mui/icons-material/Public';
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import CheckCircleIcon from '@mui/icons-material/CheckCircle'; // CheckCircle icon for better visual representation
import EventIcon from '@mui/icons-material/EventAvailable';
import ActivitiesIcon from '@mui/icons-material/Star';
import canadahero from '../img/canadahero.jpg';
import Webhead from '../Webhead';
import { useState } from 'react';
import Webfoot from '../Webfoot';


const Scanada = () => {

  const [value, setValue] = useState(0);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const benefits = [
    {
      title: "Affordable Education",
      description: "Canada offers a lower cost of living and tuition fees compared to other popular study destinations.",
      icon: <PaidIcon />
    },
    {
      title: "Innovative and Abundant Research Opportunities",
      description: "Students can engage in groundbreaking research and collaborate with leading experts.",
      icon: <SchoolIcon />
    },
    {
      title: "Immigration Possibilities",
      description: "Canada provides pathways for international students to apply for permanent residency.",
      icon: <PublicIcon />
    },
    {
      title: "Exciting Campus Lifestyle",
      description: "Experience vibrant student life, cultural diversity, and a wide range of extracurricular activities.",
      icon: <EmojiPeopleIcon />
    },
    {
      title: "Healthy and Safe Communities",
      description: "Canada is known for its safety and welcoming atmosphere, providing peace of mind to students.",
      icon: <LiveHelpIcon />
    },
    {
      title: "Work While You Study",
      description: "International students can work part-time while studying, gaining valuable experience.",
      icon: <SchoolIcon />
    },
  ];

  return (
    <div>
      <Webhead />
      <div>
        {/* <StudyInCanada /> */}
        <Container maxWidth="lg" style={{ marginTop: '20px', marginBottom: '40px' }}>

          <Box
            sx={{
              backgroundImage: `url(${canadahero})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              color: 'white',
              padding: '100px 20px',
              textAlign: 'center',
            }}
          >
            <Typography variant="h4" gutterBottom>
              Pursue Your Dreams In Canada
            </Typography>
            <Typography variant="h6" paragraph>
              Complete Admissions Support to Study in Canada
            </Typography>
            <Button variant="contained" color="primary" onClick={() => setSnackbarOpen(true)}>
              Get Started
            </Button>
          </Box>

          {/* Tabs for Different Sections */}
          <AppBar position="static" color="default">
            <Tabs value={value} onChange={handleTabChange} aria-label="tabs">
              <Tab label="Why Study in Canada?" />
              <Tab label="Get Migrated To Canada" />
              {/* <Tab label="Student Life" /> */}
            </Tabs>
          </AppBar>

          {value === 0 && (
            <>
              <Box sx={{ padding: '5px 0' }}>
                <br />
                <Box sx={{ padding: '20px', backgroundColor: '#F9BB16', borderRadius: '8px', textAlign: 'center' }}>
                  <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'black' }}>
                    Study In Canada
                  </Typography>
                </Box>
                <br />
                <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'black' }}>
                  Complete Admissions Support to Study in Canada
                </Typography>
                <Typography variant="body1" paragraph>
                  As one of the world’s favorite student destinations Canada has much to boast of. Students from across the world flock to its reputed universities to pursue courses in every discipline. Strong infrastructure, cutting edge curriculum and sprawling campuses are the hallmark of Canadian institutions. Allians works with students to help them increase their chances of studying in Canada. We help students identify and apply to the right course and right college that can serve as a Launchpad for their international career.
                </Typography>
                <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'black' }}>
                  Why Study In Canada?
                </Typography>
                <br />
                <Grid container spacing={2} justifyContent="center">


                  {benefits.map((benefit, index) => (
                    <Grid item xs={6} sm={6} md={6} key={index}>

                      <Card variant="outlined" sx={{ display: 'flex', alignItems: 'center', padding: '16px', boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)', borderRadius: '8px' }}>
                        <IconButton color="primary" sx={{ marginRight: '16px' }}>
                          {benefit.icon}
                        </IconButton>
                        <CardContent sx={{ flex: 1 }}>
                          <Typography variant="h6" gutterBottom>
                            {benefit.title}
                          </Typography>
                          {/* Uncomment below line if you want to include the description */}
                          {/* <Typography variant="body2">{benefit.description}</Typography> */}
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              </Box>
              <Box sx={{ marginTop: 4 }}>
                {/* <Typography variant="h5" gutterBottom>Frequently Asked Questions</Typography> */}
                <Accordion elevation={2} sx={{ borderRadius: '8px', marginBottom: 2 }}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: '#f5f5f5' }}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#333' }}>
                      Numerous Research Opportunities
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ backgroundColor: '#fff' }}>
                    <Box sx={{ padding: 2 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                        <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                        <Typography variant="body1">Possibility of immigration after completing the course</Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                        <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                        <Typography variant="body1">Vibrant campus atmosphere</Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                        <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                        <Typography variant="body1">International students have the option of working while studying</Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                        <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                        <Typography variant="body1">Good internship opportunities</Typography>
                      </Box>
                    </Box>
                  </AccordionDetails>
                </Accordion>

                <Accordion elevation={2} sx={{ borderRadius: '8px', marginBottom: 2 }}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: '#f5f5f5' }}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#333' }}>
                      Stay Back Period in Canada and Post Graduation Work Permit
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ backgroundColor: '#fff' }}>
                    <Box sx={{ padding: 2 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                        <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                        <Typography variant="body1">A student needs to pursue a course for a minimum duration of 8 months to be eligible to stay back in Canada</Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                        <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                        <Typography variant="body1">Course less than 8 months does not allow a client to stay back and apply for Post Graduation Work Permit</Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                        <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                        <Typography variant="body1">For post-graduation work permit a client needs to pursue a course of duration 8 months or more.
                          If the client pursues a course which is of duration less than 2 years, he/she is eligible for a post-graduation work permit of equivalent duration as the course</Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                        <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                        <Typography variant="body1">Example: 8 months course = 8 months post-graduation work permit
                          If the client pursues 2 years course (masters or diploma), he/she is eligible for a post-graduation work permit of 3 years</Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                        <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                        <Typography variant="body1">Example: 2 years masters/diploma course = 3 years post-graduation work</Typography>
                      </Box>

                    </Box>
                  </AccordionDetails>
                </Accordion>

                <Accordion elevation={2} sx={{ borderRadius: '8px', marginBottom: 2 }}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: '#f5f5f5' }}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#333' }}>
                      Cost of Studying in Canada
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ backgroundColor: '#fff' }}>
                    <Box sx={{ padding: 2 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                        <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                        <Typography variant="body1">Tuition fees in Canada vary by institution and province, but the cost is generally more affordable when compared to other countries around the world. Technical and medical courses are more expensive than arts courses. On an average, the tuition and fees range from CAD 7,000 to CAD 35,000 per year for an International student.</Typography>
                      </Box>

                    </Box>
                  </AccordionDetails>
                </Accordion>

                <Accordion elevation={2} sx={{ borderRadius: '8px', marginBottom: 2 }}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: '#f5f5f5' }}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#333' }}>
                      Numerous Research Opportunities
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ backgroundColor: '#fff' }}>
                    <Box sx={{ padding: 2 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                        <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                        <Typography variant="body1">A foreign national on a study visa in Canada can bring their spouse and dependent children to Canada. The spouse can also apply for an open work permit. They can work for a Canadian employer for the time the study visa of their partner is valid. However, if the spouse wants to study, they will have to apply for a separate study visa.</Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                        <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                        <Typography variant="body1">Study visa holders can also bring their dependent children to Canada. The children can stay for the duration of the study visa in Canada. Minor children can pursue their school education in the country provided one of their parents can either work or study in Canada. A dependent child should be below the age or 22. Children above 22 years who are not financially independent due to a physical or mental condition are also considered dependents.</Typography>
                      </Box>
                    </Box>
                  </AccordionDetails>
                </Accordion>

                <Accordion elevation={2} sx={{ borderRadius: '8px', marginBottom: 2 }}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: '#f5f5f5' }}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#333' }}>
                      After You Graduate
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ backgroundColor: '#fff' }}>
                    <Box sx={{ padding: 2 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                        <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                        <Typography variant="body1">Canada has provided ways to encourage international students and graduates to stay, gain work experience, or otherwise contribute to Canada’s economy and culture</Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                        <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                        <Typography variant="body1">In its effort to retain international students, Immigration, Refugees, and Citizenship Canada (IRCC) operates a Post-Graduate Work Permit Program. Under this program, international graduates may obtain an open work permit for up to three years</Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                        <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                        <Typography variant="body1">This allows them to work for any Canadian employer in any industry without the requirement of a Canadian job offer at the time of applying</Typography>
                      </Box>

                    </Box>
                  </AccordionDetails>
                </Accordion>

              </Box>
            </>
          )}

          {value === 1 && (
            <>
              <Divider />
              <Box sx={{ padding: '20px', borderRadius: '8px',marginTop:'15px', backgroundColor: '#fafafa' }}>
                {/* <Typography variant="h5" sx={{ fontWeight: 'bold', marginBottom: 2 }}>
                Admission Process
              </Typography>
              <Typography variant="body1" paragraph>
                The admission process for studying in Canada typically includes the following steps:
              </Typography>
              <ul style={{ listStyleType: 'none', padding: 0 }}>
                {[
                  "Choose a program and institution.",
                  "Check the admission requirements.",
                  "Prepare required documents (transcripts, letters of recommendation, etc.).",
                  "Submit your application online.",
                  "Receive an acceptance letter and pay tuition fees.",
                  "Apply for a study permit.",
                ].map((step, index) => (
                  <li key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', padding: '10px', border: '1px solid #ccc', borderRadius: '5px', backgroundColor: '#fff' }}>
                    <SchoolIcon color="primary" style={{ marginRight: '10px' }} />
                    <Typography variant="body1">{step}</Typography>
                  </li>
                ))}
              </ul> */}


                <Box sx={{ padding: '20px' }}>
                  <Typography variant="h4" sx={{ fontWeight: 'bold', marginBottom: 2 }}>
                    Why Should You Settle In Canada?
                  </Typography>
                  <Divider sx={{ marginBottom: 2 }} />
                  <Typography variant="body1" paragraph>
                    – Earn in Dollars
                  </Typography>
                  <Typography variant="body1" paragraph>
                    – Free education for children’s
                  </Typography>
                  <Typography variant="body1" paragraph>
                    – Healthcare Retirement Benefits
                  </Typography>

                  <Divider sx={{ margin: '20px 0' }} />

                  <Typography variant="h4" sx={{ fontWeight: 'bold', marginBottom: 2 }}>
                    Build a New Life in Canada
                  </Typography>
                  <Divider sx={{ marginBottom: 2 }} />
                  <Typography variant="body1" paragraph>
                    Multicultural Canada is one of the world’s best destinations for migrants. Its cosmopolitan cities, a stable economy and high quality of life make it one of the best countries to live in. Canada also has a huge demand for migrants and has opened its doors to individuals with the skills and talent to give it a global edge. As immigration consultants, we have the experience and credibility to help you with your Canada immigration process.
                  </Typography>

                  <Divider sx={{ margin: '20px 0' }} />

                  <Typography variant="h4" sx={{ fontWeight: 'bold', marginBottom: 2 }}>
                    Why Migrate to Canada?
                  </Typography>
                  <Divider sx={{ marginBottom: 2 }} />
                  <Typography variant="body1" paragraph>
                    – Huge demand for skilled immigrant talent
                  </Typography>
                  <Typography variant="body1" paragraph>
                    – Less rigorous immigration process compared to other English-speaking nations
                  </Typography>
                  <Typography variant="body1" paragraph>
                    – Free healthcare and education for permanent residents
                  </Typography>
                  <Typography variant="body1" paragraph>
                    – Safe, comfortable country with welcoming people
                  </Typography>
                  <Typography variant="body1" paragraph>
                    – Vibrant cities that are home to migrants from multiple countries
                  </Typography>

                  <Divider sx={{ margin: '20px 0' }} />

                  <Typography variant="h4" sx={{ fontWeight: 'bold', marginBottom: 2 }}>
                    Canada Immigration Process
                  </Typography>
                  <Divider sx={{ marginBottom: 2 }} />
                  <Typography variant="body1" paragraph>
                    Canada has one of the world’s most forward-thinking immigration programs. There are multiple programs by which one can apply to migrate to Canada. These include:
                  </Typography>
                  <Typography variant="body1" paragraph>
                    – Migration to Canada through Express Entry program
                  </Typography>
                  <Typography variant="body1" paragraph>
                    – Migrate to Canada through the Quebec Selected Workers Program
                  </Typography>
                  <Typography variant="body1" paragraph>
                    – Migrate to Canada through the Provincial Nominee Program
                  </Typography>
                  <Typography variant="body1" paragraph>
                    – Migrate to Canada as an Entrepreneur/self-employed person
                  </Typography>
                  <Typography variant="body1" paragraph>
                    – Migration to Canada for family
                  </Typography>
                  <Typography variant="body1" paragraph>
                    – Migrate to Canada as an Investor
                  </Typography>

                  <Divider sx={{ margin: '20px 0' }} />

                  <Typography variant="h4" sx={{ fontWeight: 'bold', marginBottom: 2 }}>
                    Who is Eligible to Apply to Canada?
                  </Typography>
                  <Divider sx={{ marginBottom: 2 }} />
                  <Typography variant="body1" paragraph>
                    While each program to migrate to Canada has different criteria, there are a few things in common. Canadian immigration officials will typically assess migration applications based on:
                  </Typography>
                  <Typography variant="body1" paragraph>
                    – Educational profile
                  </Typography>
                  <Typography variant="body1" paragraph>
                    – Professional profile
                  </Typography>
                  <Typography variant="body1" paragraph>
                    – Your IELTS score
                  </Typography>
                  <Typography variant="body1" paragraph>
                    – French language skills if migrating to Quebec
                  </Typography>
                  <Typography variant="body1" paragraph>
                    – References & legal documentation
                  </Typography>
                  <Typography variant="body1" paragraph>
                    – Canadian employment documentation
                  </Typography>
                  <Typography variant="body1" paragraph>
                    This is not an exhaustive list and subject to change. Talk to a Allians counsellor to assess your eligibility and increase your chances of migrating to Canada.
                  </Typography>
                </Box>
              </Box>
            </>
          )}

          {value === 2 && (
            <Box sx={{ padding: '20px', borderRadius: '8px', backgroundColor: '#fafafa', marginTop: 4 }}>
              <Typography variant="h5" sx={{ fontWeight: 'bold', marginBottom: 2 }}>
                Student Life
              </Typography>
              <Typography variant="body1" paragraph>
                Student life in Canada is diverse and vibrant. You can expect to engage in:
              </Typography>
              <ul style={{ listStyleType: 'none', padding: 0 }}>
                {[
                  "Participating in clubs and organizations.",
                  "Attending social events and networking opportunities.",
                  "Enjoying the cultural and recreational activities in your area.",
                ].map((activity, index) => (
                  <li key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', padding: '10px', border: '1px solid #ccc', borderRadius: '5px', backgroundColor: '#fff' }}>
                    <EventIcon color="primary" style={{ marginRight: '10px' }} />
                    <Typography variant="body1">{activity}</Typography>
                  </li>
                ))}
              </ul>

            </Box>
          )}
          {/* 
          <Box sx={{ padding: '20px' }}>
            <Typography variant="h4" sx={{ fontWeight: 'bold', marginBottom: 2 }}>
              Why Should You Settle In Canada?
            </Typography>
            <Divider sx={{ marginBottom: 2 }} />
            <Typography variant="body1" paragraph>
              – Earn in Dollars
            </Typography>
            <Typography variant="body1" paragraph>
              – Free education for children’s
            </Typography>
            <Typography variant="body1" paragraph>
              – Healthcare Retirement Benefits
            </Typography>

            <Divider sx={{ margin: '20px 0' }} />

            <Typography variant="h4" sx={{ fontWeight: 'bold', marginBottom: 2 }}>
              Build a New Life in Canada
            </Typography>
            <Divider sx={{ marginBottom: 2 }} />
            <Typography variant="body1" paragraph>
              Multicultural Canada is one of the world’s best destinations for migrants. Its cosmopolitan cities, a stable economy and high quality of life make it one of the best countries to live in. Canada also has a huge demand for migrants and has opened its doors to individuals with the skills and talent to give it a global edge. As immigration consultants, we have the experience and credibility to help you with your Canada immigration process.
            </Typography>

            <Divider sx={{ margin: '20px 0' }} />

            <Typography variant="h4" sx={{ fontWeight: 'bold', marginBottom: 2 }}>
              Why Migrate to Canada?
            </Typography>
            <Divider sx={{ marginBottom: 2 }} />
            <Typography variant="body1" paragraph>
              – Huge demand for skilled immigrant talent
            </Typography>
            <Typography variant="body1" paragraph>
              – Less rigorous immigration process compared to other English-speaking nations
            </Typography>
            <Typography variant="body1" paragraph>
              – Free healthcare and education for permanent residents
            </Typography>
            <Typography variant="body1" paragraph>
              – Safe, comfortable country with welcoming people
            </Typography>
            <Typography variant="body1" paragraph>
              – Vibrant cities that are home to migrants from multiple countries
            </Typography>

            <Divider sx={{ margin: '20px 0' }} />

            <Typography variant="h4" sx={{ fontWeight: 'bold', marginBottom: 2 }}>
              Canada Immigration Process
            </Typography>
            <Divider sx={{ marginBottom: 2 }} />
            <Typography variant="body1" paragraph>
              Canada has one of the world’s most forward-thinking immigration programs. There are multiple programs by which one can apply to migrate to Canada. These include:
            </Typography>
            <Typography variant="body1" paragraph>
              – Migration to Canada through Express Entry program
            </Typography>
            <Typography variant="body1" paragraph>
              – Migrate to Canada through the Quebec Selected Workers Program
            </Typography>
            <Typography variant="body1" paragraph>
              – Migrate to Canada through the Provincial Nominee Program
            </Typography>
            <Typography variant="body1" paragraph>
              – Migrate to Canada as an Entrepreneur/self-employed person
            </Typography>
            <Typography variant="body1" paragraph>
              – Migration to Canada for family
            </Typography>
            <Typography variant="body1" paragraph>
              – Migrate to Canada as an Investor
            </Typography>

            <Divider sx={{ margin: '20px 0' }} />

            <Typography variant="h4" sx={{ fontWeight: 'bold', marginBottom: 2 }}>
              Who is Eligible to Apply to Canada?
            </Typography>
            <Divider sx={{ marginBottom: 2 }} />
            <Typography variant="body1" paragraph>
              While each program to migrate to Canada has different criteria, there are a few things in common. Canadian immigration officials will typically assess migration applications based on:
            </Typography>
            <Typography variant="body1" paragraph>
              – Educational profile
            </Typography>
            <Typography variant="body1" paragraph>
              – Professional profile
            </Typography>
            <Typography variant="body1" paragraph>
              – Your IELTS score
            </Typography>
            <Typography variant="body1" paragraph>
              – French language skills if migrating to Quebec
            </Typography>
            <Typography variant="body1" paragraph>
              – References & legal documentation
            </Typography>
            <Typography variant="body1" paragraph>
              – Canadian employment documentation
            </Typography>
            <Typography variant="body1" paragraph>
              This is not an exhaustive list and subject to change. Talk to a Allians counsellor to assess your eligibility and increase your chances of migrating to Canada.
            </Typography>
          </Box> */}

          {/* FAQ Accordion */}


          {/* Snackbar for user feedback */}
          <Snackbar
            open={snackbarOpen}
            onClose={handleSnackbarClose}
            message="Get Started button clicked!"
            autoHideDuration={4000}
          />
        </Container>
      </div>
      <Webfoot />
    </div>
  );
};

export default Scanada;